import { useApi, createApiHook } from "../utils/apiUtils";

const useToggleApplicationEnabled = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const toggleApplicationEnabled = async ({ appId, enabled }) => {
    startLoading();
    const response = await apiPatch(`/aplicaciones/${appId}/toggle_enabled`, "Error al habilitar/deshabilitar la aplicación", {
      enabled,
    });
    setResponse(response);

    return !response?.error;
  };

  return { toggleApplicationEnabled, data, error, loading };
};

export default useToggleApplicationEnabled;
